export const HOMEPAGE_SEARCH_MIN_QUERY_LENGTH = 2;

export function normalizeHomepageSearchQuery(query: string) {
	return query.trim();
}

export function isHomepageSearchEnabled(query: string) {
	return (
		normalizeHomepageSearchQuery(query).length >=
		HOMEPAGE_SEARCH_MIN_QUERY_LENGTH
	);
}

export function shouldOpenHomepageSearchPanel(
	query: string,
	isFocused: boolean,
) {
	return isFocused && normalizeHomepageSearchQuery(query).length > 0;
}

export function getHomepageAgentRouteSegment(agent: {
	displayPathSegment?: string;
	slug: string;
}) {
	return agent.displayPathSegment || agent.slug;
}
